import { Card, CardHeader, CardContent, Grid, Typography } from "@mui/material";

import LitcoLogo from "../../../../images/LitcoLogo";

export default function BookingStep(props) {
  const { header, align, subheader, actions, children, xs, sm, md, lg, xl, width } = props;
  let titleContent = null;

  if (header === "default") {
    titleContent = <LitcoLogo size={25} opacity={0.6} />;
  } else {
    titleContent =
      typeof header === "string" ? (
        <Typography variant="h6" component="div">
          {header}
        </Typography>
      ) : (
        header
      );
  }

  return (
    <Grid
      container
      height="100%"
      alignItems="center"
      justifyContent="center"
      sx={{ overflowY: "auto", overflowX: "hidden" }}
    >
      <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl} width={width}>
        <Card sx={{margin: "5px 0"}}>
          {(header || subheader) && (
            <CardHeader title={titleContent} subheader={subheader} sx={{ textAlign: align, paddingBottom: 0 }} />
          )}

          <CardContent
            sx={{
              "&:last-child": {
                paddingBottom: 2,
              },
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {children}
              </Grid>
              {actions && (
                <Grid item xs={12}>
                  {actions}
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
